import React from "react";
import { useCapabilities } from "@/lib/capabilities";
import { Panel } from "@/components/common/Panel";
import { ShieldX } from "lucide-react";

/**
 * Wrap an engine page; show a soft-deny panel when the user's roles do not include
 * the required capability key (one of: can_authorization, can_su24, can_odata, is_admin).
 */
export default function RoleGate({ require: requiredCap, label, children }) {
    const { caps } = useCapabilities();
    if (caps && !caps[requiredCap]) {
        return (
            <Panel eyebrow="Access Restricted" title={`${label} is not enabled for your role`}>
                <div className="flex items-start gap-3 text-sm">
                    <ShieldX size={18} className="text-rose-400 mt-0.5" />
                    <p className="text-slate-400 leading-relaxed">
                        Your assigned execution role(s) do not include access to the {label} engine.
                        Ask a platform owner to grant <span className="font-mono text-cyan-300">Execution_All</span>
                        {" "}or the specific role for this engine.
                    </p>
                </div>
            </Panel>
        );
    }
    return children;
}
